import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyRS } from 'src/app/core/models/site-settings/currency-rs';

@Component({
  selector: 'app-add-currency-modal',
  templateUrl: './add-currency-modal.component.html',
  styleUrls: ['./add-currency-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddCurrencyModalComponent implements OnInit {
  @Input() modalTitle:string;
  @Input() dataObject:any[];
  @Input() selectedObject:any;
  @Input() labelReference:string;

  selectedCurrency:CurrencyRS;

  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit(): void {
  }


  onSelectCurrency(event){
    this.selectedObject = event.id;
    this.selectedCurrency = event;
  }
}
